import type { DropAnimation } from "@dnd-kit/core";
import { CSS } from "@dnd-kit/utilities";
import type { TableMotion } from "../../motion/tableMotion";
import type { DragInput } from "./dragKind";

/**
 * The preview's landing: it glides onto the dragged item's new place and
 * fades into it. Reduced motion keeps only the fade; keyboard drops and
 * `data-motion="none"` drop instantly. `motion` is read once per drag, so a
 * retimed table (slow motion) retimes the drop too.
 */
export const getDropAnimation = ({
    motion,
    input,
}: {
    motion: TableMotion | null;
    input: DragInput;
}): DropAnimation | null => {
    if (!motion || input === "keyboard" || motion.isOff) {
        return null;
    }
    return {
        duration: motion.isReduced ? motion.fastMs : motion.mediumMs,
        easing: motion.easeOut,
        sideEffects: null,
        keyframes: ({ transform }) => {
            const from = CSS.Transform.toString(transform.initial);
            const to = motion.isReduced
                ? from
                : CSS.Transform.toString(transform.final);
            return [
                { transform: from, opacity: 1 },
                { transform: to, opacity: 0 },
            ];
        },
    };
};
